module.exports = __webpack_public_path__ + "img/espaço-4.9fca52a2.jpeg";